import type { ResultAttempt } from '../types/results';

/**
 * Vypocet uredniho casu jedne drahy z mereni 1-3 casomericu. Sjednoceno
 * s backendem (OfficialTimeCalculator): 1 mereni = to, 2 mereni = horsi
 * pokud se rozchazi, 3 mereni = median (resp. 2-ze-3 shoda).
 */
export const computeLaneOfficialTimeMs = (laneAttempts: ResultAttempt[]): number | null => {
  if (!laneAttempts || laneAttempts.length === 0) return null;
  if (laneAttempts.some((a) => a.isNp)) return null;
  const valid = laneAttempts
    .map((a) => a.timeMs)
    .filter((t): t is number => t != null && t > 0)
    .sort((a, b) => a - b);
  if (valid.length === 0) return null;
  if (valid.length === 1) return valid[0];
  if (valid.length === 2) return valid[0] === valid[1] ? valid[0] : valid[1]; // horsi
  const [a, b, c] = valid;
  if (a === b) return a;
  if (b === c) return b;
  if (a === c) return a;
  return b; // median
};
